import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { lighten, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Button from "@material-ui/core/Button";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useNavigate } from "react-router-dom";
import { Alert } from "reactstrap";
import SearchBar from "material-ui-search-bar";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import CircularProgress from "@material-ui/core/CircularProgress";
import CardContent from "@material-ui/core/CardContent";
import Card from "@material-ui/core/Card";
import { fetchWithToken } from "../../../apiUtils";

function descendingComparator(a, b, orderBy) {
  if (a[orderBy] === null) {
    return -1;
  } else if (b[orderBy] === null) {
    return 1;
  } else if (b[orderBy] < a[orderBy]) {
    return -1;
  } else if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const headCells = [
  { id: "did", label: "Number" },
  { id: "description", label: "Status" },
  { id: "gmid", label: "GMID" },
  { id: "statusComment", label: "Comment" },
  { id: "displayName", label: "Display Name" },
  { id: "dialPlan", label: "Dial Plan" },
  { id: "voicePolicy", label: "Voice Policy" },
];

function EnhancedTableHead(props) {
  const {
    classes,
    order,
    orderBy,
    onRequestSort,
    setSearched,
    setPage,
    searchedObj,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const handleInput = (searchVal, domain) => {
    setPage(0);
    setSearched({ searched: searchVal, domain: domain });
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align="center"
            paddingBottom="50px"
            style={{ fontSize: "1vw", padding: "5px" }}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <div
              class="input-group"
              style={{
                justifyContent: "center",
                margin: "auto",
                marginBottom: "8px",
              }}
            >
              {headCell.id == "description" && (
                <select
                  class="form-control"
                  name="description"
                  style={{ width: "80%", margin: "auto" }}
                  onChange={(searchVal) =>
                    handleInput(
                      searchVal.target.value.toString(),
                      "description"
                    )
                  }
                >
                  <option value=""> Status </option>
                  <option value="Assigned">Assigned</option>
                  <option value="Blocked">Blocked</option>
                  <option value="Reserved">Reserved</option>
                  <option value="Unassigned">Unassigned</option>
                </select>
              )}
              {headCell.id == "did" && (
                <SearchBar
                  placeholder="Number"
                  value={
                    searchedObj.domain === "did" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "did")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ maxWidth: "80%" }}
                />
              )}
              {headCell.id == "gmid" && (
                <SearchBar
                  placeholder="GMID"
                  value={
                    searchedObj.domain === "gmid" ? searchedObj.searched : ""
                  }
                  onChange={(searchVal) => handleInput(searchVal, "gmid")}
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id == "displayName" && (
                <SearchBar
                  placeholder="Display Name"
                  value={
                    searchedObj.domain === "displayName"
                      ? searchedObj.searched
                      : ""
                  }
                  onChange={(searchVal) =>
                    handleInput(searchVal, "displayName")
                  }
                  onCancelSearch={() => setSearched("")}
                  className={classes.searchbar}
                  style={{ width: "80%" }}
                />
              )}
              {headCell.id != "description" && (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : "asc"}
                  onClick={createSortHandler(headCell.id)}
                >
                  {(headCell.id == "statusComment" ||
                    headCell.id == "dialPlan" ||
                    headCell.id == "voicePolicy") && (
                    <div
                      align="center"
                      style={{ fontSize: ".9vw", margin: "auto" }}
                    >
                      {headCell.label}
                    </div>
                  )}

                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                      {order === "desc"
                        ? "sorted descending"
                        : "sorted ascending"}
                    </span>
                  ) : null}
                </TableSortLabel>
              )}
            </div>
          </TableCell>
        ))}
        <TableCell
          align="center"
          paddingBottom="50px"
          style={{ fontSize: "1vw", padding: "5px" }}
        >
          <div
            style={{
              justifyContent: "center",
              margin: "auto",
              marginBottom: "8px",
            }}
          >
            View
          </div>
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
    margin: 40,
  },
  smallColumn: {
    width: "1px",
  },
}));

const EnhancedTableToolbar = (props) => {
  const classes = useToolbarStyles();

  return (
    <Toolbar className={classes.root}>
      <Typography
        className={classes.title}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        Endpoints
      </Typography>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  loading: {
    marginLeft: "50%",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  smallColumn: {
    width: "10px",
  },
  searchbar: {
    width: "160px",
    height: "40px",
  },
  modal: {
    padding: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const PhoneNumberTable = (props) => {
  const history = useNavigate();
  const { data } = props;
  const classes = useStyles();
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("id");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rows, setRows] = useState(data);
  const [searchedObj, setSearched] = useState({ searched: "", domain: "" });

  useEffect(() => {
    setRows(data);
  }, [data]);

  const handleFilter = () => {
    const filteredRows = rows.filter((row) => {
      if (searchedObj.domain === "gmid" && row.gmid == null) {
        return;
      }
      if (searchedObj.domain === "displayName" && row.displayName == null) {
        return;
      }
      if (searchedObj.domain === "description" && searchedObj.searched != "") {
        return (
          row.description.toString().toLowerCase() ===
          searchedObj.searched.toLowerCase()
        );
      }
      if (searchedObj.domain === "did") {
        return row.did
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "gmid" && row.gmid != null) {
        return row.gmid
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      }
      if (searchedObj.domain === "displayName" && row.displayName != null) {
        return row.displayName
          .toString()
          .toLowerCase()
          .includes(searchedObj.searched.toLowerCase());
      } else return rows;
    });
    return filteredRows;
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleDelete = (id) => {
    fetchWithToken(`api/Carriers/${id}`, "DELETE").then((res) => {
      if (res.ok) {
        let newRows = rows.filter((row) => row.id !== id);
        setRows(newRows);
        sendAlert(`Carrier ${id} - Successfully Deleted`, "success");
      } else if (res.status === 409) {
        sendAlert(`Conflict - `, "danger");
      } else {
        sendAlert(`Unknown Error - `, "warning");
      }
    });
  };

  const [alertMessage, setAlertMessage] = useState({
    message: "",
    active: false,
  });

  const sendAlert = (message, varient) => {
    setAlertMessage({
      message: message,
      varient: varient,
      active: true,
    });

    const timer = setTimeout(() => {
      setAlertMessage({
        message: "",
        varient: "",
        active: false,
      });
    }, 8500);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows =
    handleFilter().length < rowsPerPage
      ? 0
      : rowsPerPage -
        Math.min(rowsPerPage, handleFilter().length - page * rowsPerPage);

  return (
    <>
      <div className={classes.root}>
        {alertMessage.active && (
          <Alert color={alertMessage.varient}>{alertMessage.message}</Alert>
        )}

        <Paper className={classes.paper}>
          <EnhancedTableToolbar />
          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <EnhancedTableHead
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={handleFilter().length}
                setSearched={setSearched}
                setPage={setPage}
                searchedObj={searchedObj}
              />
              <TableBody>
                {stableSort(handleFilter(), getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={index}
                        style={{ height: "40px" }}
                      >
                        <TableCell align="center" style={{ width: "14%" }}>
                          {row.did}
                        </TableCell>
                        <TableCell align="center" style={{ width: "13%" }}>
                          {row.description}
                        </TableCell>
                        <TableCell align="center" style={{ width: "14%" }}>
                          {row.gmid}
                        </TableCell>
                        <TableCell align="left" style={{ width: "11%" }}>
                          {row.statusComment}
                        </TableCell>
                        <TableCell align="left" style={{ width: "17%" }}>
                          {row.displayName}
                        </TableCell>
                        <TableCell align="center" style={{ width: "14%" }}>
                          {row.dialPlan}
                        </TableCell>
                        <TableCell align="center" style={{ width: "14%" }}>
                          {row.voicePolicy}
                        </TableCell>
                        {row.description == "Assigned" && row.gmid != null ? (
                          <TransitionsModal gmid={row.gmid} />
                        ) : (
                          <TableCell
                            className={classes.smallColumn}
                            style={{ width: "4%" }}
                          >
                            <Button variant="contained" size="small" disabled>
                              <VisibilityIcon />
                            </Button>
                          </TableCell>
                        )}
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height:
                        handleFilter().length > rowsPerPage
                          ? 65 * emptyRows
                          : 65,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={handleFilter().length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangeRowsPerPage={handleChangeRowsPerPage} // Material v < 4
            onRowsPerPageChange={handleChangeRowsPerPage} // Material v > 4
            onPageChange={handleChangePage} // Material v > 4
            onChangePage={handleChangePage} // Material v < 4
          />
        </Paper>
      </div>
    </>
  );
};

const TransitionsModal = (props) => {
  const classes = useStyles();
  const { gmid } = props;
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [endpoint, setEndpoint] = useState(false);

  const handleOpen = (gmid) => {
    fetchWithToken(`api/TeamsEndpoint/ByGmid/${gmid}`)
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setEndpoint({
          phoneNumber: data.phoneNumber,
          gmid: data.gmid,
          name: data.name,
          displayName: data.displayName,
          poolName: data.pool.name,
          assignmentDate: data.assignmentDate,
          dialPlan: data.dialPlan,
          voicePolicy: data.voicePolicy,
          sipAddress: data.sipAddress,
          sip: data.sip,
          siteId: data.siteId,
          upn: data.upn,
        });
      });
    setOpen(true);
  };

  const getDateFormat = (date) => {
    if (date == null) return;
    var newDate = date.split("T")[0];
    var dateArray = newDate.split("-");
    var year = dateArray[0];
    var month = dateArray[1];
    var day = dateArray[2];
    var fullTime = date.split("T")[1].split(".")[0];
    var hour = fullTime.substring(0, 2);
    var myDate = `${year}-${month}-${day}`;
    return myDate;
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <TableCell className={classes.smallColumn} style={{ width: "4%" }}>
        <Button
          variant="contained"
          size="small"
          onClick={() => handleOpen(gmid)}
        >
          <VisibilityIcon />
        </Button>
      </TableCell>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div style={{ minWidth: "600px", maxWidth: "700px" }}>
            <Card
              className={classes.datailCard}
              style={{ minWidth: "250px", maxWidth: "700px" }}
            >
              {loading ? (
                <CircularProgress className={classes.loading} />
              ) : (
                <>
                  <CardContent style={{ width: "73%" }}>
                    <Typography
                      sx={{ fontSize: 14 }}
                      style={{ fontSize: "1.5em" }}
                      color="text.secondary"
                      gutterBottom
                    >
                      Existing Endpoint
                    </Typography>
                    <div style={{ margin: "20px" }}>
                      <div class="mb-3 row">
                        <div class="col-sm-6">
                          <h6>Number:</h6>
                        </div>
                        <div class="col-sm-6">
                          <h6>{endpoint.phoneNumber}</h6>
                        </div>
                      </div>

                      <div class="mb-3 row">
                        <div class="col-sm-6">
                          <h6>GMID:</h6>
                        </div>
                        <div class="col-sm-6">
                          <h6>{endpoint.gmid}</h6>
                        </div>
                      </div>

                      <div class="mb-3 row">
                        <div class="col-sm-6">
                          <h6>Display Name:</h6>
                        </div>
                        <div class="col-sm-6">
                          <h6>{endpoint.displayName}</h6>
                        </div>
                      </div>

                      <div class="mb-3 row">
                        <div class="col-sm-6">
                          <h6>Pool Name:</h6>
                        </div>
                        <div class="col-sm-6">
                          <h6>{endpoint.poolName}</h6>
                        </div>
                      </div>

                      <div class="mb-3 row">
                        <div class="col-sm-6">
                          <h6>Dial Plan:</h6>
                        </div>
                        <div class="col-sm-6">
                          <h6>{endpoint.dialPlan}</h6>
                        </div>
                      </div>

                      <div class="mb-3 row">
                        <div class="col-sm-6">
                          <h6>Voice Policy:</h6>
                        </div>
                        <div class="col-sm-6">
                          <h6>{endpoint.voicePolicy}</h6>
                        </div>
                      </div>

                      <div class="mb-3 row">
                        <div class="col-sm-6">
                          <h6>Assignment Date:</h6>
                        </div>
                        <div class="col-sm-6">
                          <h6>{getDateFormat(endpoint.assignmentDate)}</h6>
                        </div>
                      </div>

                      <div class="mb-3 row">
                        <div class="col-sm-6">
                          <h6>SIP Address</h6>
                        </div>
                        <div class="col-sm-6">
                          <h6>{endpoint.sipAddress}</h6>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </>
              )}
            </Card>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default PhoneNumberTable;
